import { render } from "./BadgeCenterDialog.vue?vue&type=template&id=70a01b23&scoped=true"
import script from "./BadgeCenterDialog.vue?vue&type=script&lang=js"
export * from "./BadgeCenterDialog.vue?vue&type=script&lang=js"

import "./BadgeCenterDialog.vue?vue&type=style&index=0&id=70a01b23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a01b23"]])

export default __exports__